var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"functionListDiv"},[_c('div',{staticClass:"functionListTab"},[_c('WaterFee')],1),_c('div',{staticClass:"footerArea"},[_vm._v("© 2020 马鞍山首创水务有限责任公司 All Rights Reserved")])])}
var staticRenderFns = []

export { render, staticRenderFns }